__turbopack_context__.v({
  "switcher": "Switcher-module-scss-module__23TN0q__switcher",
});
